import { useTranslation } from "react-i18next";
import { IControl } from "../../types/map-type";

import "./style.scss";

type MapIconButtonProps = {
	handleClick: (identifier: string) => void;
	data: IControl;
	isActive: boolean;
};

export const MapIconButton = ({
	data,
	handleClick,
	isActive,
}: MapIconButtonProps) => {
	const { t } = useTranslation();
	const { text, img } = data;

	return (
		<button
			data-active={isActive}
			onClick={() => handleClick(text)}
			className="map-icon-button"
		>
			<img src={img} alt={text} />
			<p>{t(text)}</p>
		</button>
	);
};

export default MapIconButton;
